import { render } from "./QuotationInformation.vue?vue&type=template&id=5a06fda5"
import script from "./QuotationInformation.vue?vue&type=script&lang=js"
export * from "./QuotationInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__